import { useEffect, useState } from 'react'

interface Props {
  initials: string
  name?: string
  picture?: string
  fallbackPicture?: string
  className?: string
}

export function UserAvatar({ initials, name, picture, fallbackPicture, className = 'avatar' }: Props) {
  const [sourceIndex, setSourceIndex] = useState(0)
  const sources = [picture, fallbackPicture].filter((source, index, items): source is string => Boolean(source) && items.indexOf(source) === index)
  const activeSource = sources[sourceIndex]

  useEffect(() => setSourceIndex(0), [picture, fallbackPicture])

  if (activeSource) {
    return <img
      className={`${className} user-avatar-photo`}
      src={activeSource}
      alt={name ? `Foto de ${name}` : ''}
      title={name}
      referrerPolicy="no-referrer"
      decoding="async"
      onError={() => setSourceIndex(index => index + 1)}
    />
  }

  return <span className={className} title={name}>{initials}</span>
}
